import { render } from "./deleteEntreprise.vue?vue&type=template&id=37ce3ae7&scoped=true"
import script from "./deleteEntreprise.vue?vue&type=script&lang=js"
export * from "./deleteEntreprise.vue?vue&type=script&lang=js"

import "./deleteEntreprise.vue?vue&type=style&index=0&id=37ce3ae7&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ce3ae7"]])

export default __exports__